/** @deprecated Agents UI moved to AgentsManagerModal; rail uses AgentsSidebarToggle only. */
export const AgentsSidebar = function AgentsSidebar() {
	return null;
};
